import { BaseModel } from './base-model';
import { TimeEntry } from './time-entry';

export class Timesheet extends BaseModel {
    uid: string;
    week: string;
    timeEntries: TimeEntry[];
    approved: boolean = false;
}
